import { useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import Stepper from "react-stepper-horizontal";
import AssignAgentLocation from "./AssignAgentLocation";
import { toastError } from "../../utils/toastrResponse";
import { useFetchData } from "../../hooks/useFetchData";
import DOMPurify from "dompurify";
import useAxios from "../../hooks/useAxios";

const CreateAgent = ({ show, hide }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [isValid, setIsValid] = useState(false);
  const [agentId, setAgentId] = useState();
  const [newAgent, setNewAgent] = useState({
    phoneNumber: "",
    typeId: "",
    statusId: "",
    commissionRate: "",
  });
  const formRef = useRef();
  const axiosInstance = useAxios();
  const createAgent = (e) => {
    e.preventDefault();
    const url = `/agents`;
    axiosInstance({
      url,
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: newAgent,
    })
      .then((res) => {
        if (res.status >= 200 && res.status <= 300) {
          formRef.current.reset();
          setActiveStep(1);
          setAgentId(res?.data.id);
        } else {
          toastError("Could not create Agent");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  // fetch agents statuses
  const { data: agentStatuses } = useFetchData(
    ["fetch-agent-status"],
    "agents/statuses",
    true
  );
  // fetch agents types
  const { data: agentTypes } = useFetchData(
    ["fetch-agent-types"],
    "agents/types",
    true
  );
  const handleInputChange = (e) => {
    const { value, name } = e.target;
    setNewAgent({
      ...newAgent,
      [name]: DOMPurify.sanitize(value),
    });
  };
  return (
    <div>
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
      >
        <Modal.Header closeButton onClick={hide}>
          <h5>
            {activeStep === 0 ? "Create Agent" : "Assign Location to Agent"}
          </h5>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f0f0fa" }}>
          <Stepper
            steps={[{ title: "Create Agent" }, { title: "Assign Location" }]}
            activeStep={activeStep}
          />
          {activeStep === 0 && (
            <form className='mt-5' ref={formRef} onSubmit={createAgent}>
              <label className='ml-2'>Agent Firstname</label>
              <input
                className='form-control input-select mb-2'
                placeholder='Enter firstname'
                name='firstName'
                onChange={handleInputChange}
                required
              />
              <label className='ml-2'>Agent Lastname</label>
              <input
                className='form-control input-select mb-2'
                placeholder='Enter lastname'
                name='lastName'
                onChange={handleInputChange}
                required
              />
              <label className='ml-2'>Phone number</label>
              <input
                className='form-control input-select mb-2'
                placeholder='Phone Number'
                name='phoneNumber'
                onChange={(e) => {
                  const { value } = e.target;
                  setNewAgent({
                    ...newAgent,
                    phoneNumber: `25${value}`,
                  });
                  const regex = /^07[9823]\d{7}$/;
                  const isValidPhoneNumber = regex.test(value);
                  setIsValid(isValidPhoneNumber);
                }}
                required
              />
              {!isValid && newAgent?.phoneNumber.length > 1 && (
                <span style={{ color: "red" }}>
                  Please enter a valid phone number.
                  <br />
                </span>
              )}
              <label className='ml-2'>Type</label>
              <select
                placeholder='Type'
                name='typeId'
                className='form-control input-select mb-2'
                onChange={handleInputChange}
                required
              >
                <option value=''>select type</option>
                {agentTypes?.map((type) => (
                  <option value={type.id} key={type.id}>
                    {type.name}
                  </option>
                ))}
              </select>
              <label className='ml-2'>Status</label>
              <select
                placeholder='Status'
                name='statusId'
                className='form-control input-select mb-2'
                onChange={handleInputChange}
                required
              >
                <option value=''>select status</option>
                {agentStatuses?.map((status) => (
                  <option value={status.id} key={status.id}>
                    {status.name}
                  </option>
                ))}
              </select>
              <label className='ml-2'>Commission Rate</label>
              <select
                placeholder='Status'
                name='commissionRate'
                className='form-control input-select mb-2'
                onChange={handleInputChange}
                required
              >
                <option value=''>Choose commission</option>
                <option value={0.1}>10%</option>
              </select>
              <div className='d-flex justify-content-center'>
                <Button
                  disabled={
                    !isValid ||
                    newAgent.statusId === "" ||
                    newAgent.typeId === "" ||
                    newAgent.commissionRate === ""
                  }
                  className='custom-btn-color'
                  type='submit'
                >
                  Next Step
                </Button>
              </div>
            </form>
          )}
          {activeStep === 1 && (
            <AssignAgentLocation
              setStep={setActiveStep}
              agentId={agentId}
              hide={hide}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CreateAgent;
